var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 19,
    viewBox: "0 0 25 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 14.95L2.79167 9.9917C2.66201 9.86046 2.50759 9.75626 2.33736 9.68514C2.16714 9.61403 1.98448 9.57741 1.8 9.57741C1.61551 9.57741 1.43286 9.61403 1.26264 9.68514C1.09241 9.75626 0.93799 9.86046 0.808332 9.9917C0.677093 10.1214 0.572895 10.2758 0.501778 10.446C0.430662 10.6162 0.394043 10.7989 0.394043 10.9834C0.394043 11.1679 0.430662 11.3505 0.501778 11.5207C0.572895 11.691 0.677093 11.8454 0.808332 11.975L6.74417 17.9109C7.29667 18.4634 8.18917 18.4634 8.74166 17.9109L23.7583 2.90836C23.8896 2.77871 23.9938 2.62429 24.0649 2.45406C24.136 2.28383 24.1726 2.10118 24.1726 1.9167C24.1726 1.73221 24.136 1.54956 24.0649 1.37933C23.9938 1.20911 23.8896 1.05469 23.7583 0.925031C23.6287 0.793792 23.4743 0.689593 23.304 0.618477C23.1338 0.547361 22.9512 0.510742 22.7667 0.510742C22.5822 0.510742 22.3995 0.547361 22.2293 0.618477C22.0591 0.689593 21.9047 0.793792 21.775 0.925031L7.75 14.95Z",
    fill: "#344054"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDone);
export default __webpack_public_path__ + "static/media/done.2578ff136f5356c1a7d71ee3328cc5a5.svg";
export { ForwardRef as ReactComponent };